import React, { useState } from "react";
import EdButton from "../../../generic/edButton";
import Search from "../../../generic/search";
import "../../../../assets/scss/components/toc/orderBook/obContainer/obUtilHeader.scss";
import DeviceContext from "../../../service/indentifyDevice";
import ObFilter from "../generic/obFilter";
import indexer from "../../../types/genericTypes";

export interface IObUtilHeaderProps {
	leftSideText: React.ReactElement; // data to show on the left part of util bar
	data: Array<Array<any>>; // data to be searched or filtered
	searchKey: string; // key on which search needs to be performed
	onDataFilter: (filteredData: any[], sText?: string, type?: string) => void; // returns filtered array after searching
	onSelectClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void; // event after clicking on select button
	onFilterClick: (toggle: boolean) => void; // event after clicking on filter button
	onSearchClick: (hidePriNav: boolean) => void; // event after clicking on search button
	filterReqData?: indexer;
}

export enum EUtilHeaderState {
	NORMAL,
	SELECT,
	FILTER,
	SEARCH
}

const ObUtilHeader: React.FC<IObUtilHeaderProps> = (props) => {
	const [utilHeaderState, setUtilHeaderState] = useState(EUtilHeaderState.NORMAL);
	function onSearchClick(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
		setUtilHeaderState(EUtilHeaderState.SEARCH);

		props.onSearchClick(true);
	}

	function onCancelClick() {
		setUtilHeaderState(EUtilHeaderState.NORMAL);
		props.onSearchClick(false);
		props.onDataFilter(props.data, "", "search");
	}

	return (
		<>
			{utilHeaderState === EUtilHeaderState.NORMAL && (
				<div className="util_cont">
					<div>{props.leftSideText}</div>

					<div className="utils">
						{props.onSelectClick && (
							<span className="ib vMid">
								<EdButton
									value={
										<>
											<i className="select edel-icon-select vTextTop btn_icon" />
											<span>Select</span>
										</>
									}
									btnTyp="blue-link"
									onClick={props.onSelectClick}
								/>
							</span>
						)}
						{props.data[0].length > 0 && (
							<span className="ib vMid">
								<ObFilter
									data={props.data}
									onFilter={(filteredData: Array<any>) => {
										// remove all the empty arrays
										props.onDataFilter(filteredData.filter((data) => data.length));
									}}
									tglClick={props.onFilterClick}
									filterInputParams={props.filterReqData || { status: "sts" }}
								/>
							</span>
						)}
						{props.data[0].length > 0 && (
							<span className="ib vMid">
								<EdButton
									value={
										<>
											<i className="search edel-icon-search vTextTop btn_icon" />
											{!DeviceContext().isMobile && <span>Search</span>}
										</>
									}
									btnTyp="blue-link"
									onClick={onSearchClick}
									className="search_btn"
								/>
							</span>
						)}
					</div>
				</div>
			)}
			{utilHeaderState === EUtilHeaderState.SEARCH && (
				<div className="util_cont search_active">
					{/* Search takes 1D array and returns 1D array
					So we need to convert it accordingly */}
					<Search
						searchList={props.data}
						searchKey={props.searchKey}
						onSearch={(data, sText, type) => props.onDataFilter(data, sText, type)}
						classname="active"
					/>
					<EdButton value="close" btnTyp="link" onClick={onCancelClick} />
				</div>
			)}
		</>
	);
};

export default ObUtilHeader;
